import Heading from 'common/components/Heading';
import Text from 'common/components/Text';
import Container from 'common/components/UI/Container';
import { graphql, useStaticQuery } from 'gatsby';
import React, { useState } from 'react';
import { PiCheckCircleFill } from 'react-icons/pi';
import { useMediaQuery } from 'react-responsive';
import SectionWrapper, {
  ButtonGroup, InnerWrapper, PricingArea, PricingCard,
  SectionHeader
} from './pricingPolicy.style';

const PricingPolicy = (props) => {
  const data = useStaticQuery(graphql`
    query {
      appJson {
        pricing {
          currency
          plans {
            monthly {
              button {
                label
                link
              }
              description
              features {
                id
                text
              }
              id
              period
              price
              title
            }
            yearly {
              button {
                label
                link
              }
              description
              features {
                id
                text
              }
              id
              period
              price
              title
            }
          }
          save
          slogan
          title
        }
      }
    }
  `);

  const { appJson: pricing } = data;

  const items = pricing?.pricing;

  const { slogan, title, save, currency } = items || {};
  const keys = Object?.keys(items?.plans || []).slice(0, 2);
  const [state, setState] = useState({
    active: `${keys[0]?.toString()}`,
    pricingPlan: items?.plans[keys[0]],
  });

  const handlePricingPlan = (plan) => {
    if (!keys.includes(plan)) {
      return;
    }
    setState({
      active: plan,
      pricingPlan: items?.plans[plan],
    });
  };

  const isDesktop = useMediaQuery({
    query: '(min-width: 401px)',
  });

  return (
    <SectionWrapper id="pricing" {...props}>
      <Container>
        <SectionHeader>
          <Heading content={slogan} />
          <Text content={title} />
        </SectionHeader>
        {keys?.length ?
        <ButtonGroup>
          <div className='button_groups_outer_wrapper'>
            <div className='button_groups_wrapper'>
              {keys?.map((key, value) => {
                  return (
                    <React.Fragment key={key}>
                      <label className={`switch_button_${value} switch_button ${state?.active === key ? 'checked' : ''}`}>
                        <span>{key?.charAt(0)?.toUpperCase() + key?.slice(1)}</span>
                        <input
                          checked={state?.active === key}
                          onChange={() => handlePricingPlan(key)}
                          type="radio"
                          name='pricing'
                        />
                      </label>
                    </React.Fragment>
                  )
              })}
              <div className="switch_outer"><div className="switch_inner"></div></div>
            </div>
            {isDesktop && <div className='promotion_alert_box'>{save}</div>}
          </div>
        </ButtonGroup>
        :
        ""
        }

        <PricingArea>
          <InnerWrapper>
            {state?.pricingPlan?.map((item, index) => {
              const isHighlighted = index === 1;
              const isNumericPrice = Boolean(item?.price);
              return (
                <PricingCard key={item?.id} highlighted={isHighlighted}>
                  <div className="card-header">
                    {isHighlighted && <span className="card-ribbon">Most popular</span>}
                    <Heading as="h3" content={item?.title} />
                    <div className={`price ${isNumericPrice ? 'price--number' : 'price--text'}`}>
                      {isNumericPrice ? (
                        <>
                          <span className="symbol">{currency}</span>
                          <span className="amount">{item?.price}</span>
                          <span className="state">/{item?.period}</span>
                        </>
                      ) : (
                        <span className="amount">{item?.price === 0 ? 'Free' : 'See in app'}</span>
                      )}
                    </div>
                    <Text content={item?.description} />
                  </div>
                  <div className="card-body">
                    <ul className="feature-list">
                      {item?.features?.map(feature => (
                        <li key={feature?.id}>
                          <PiCheckCircleFill aria-hidden="true" /> {feature?.text}
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div className="card-footer">
                    <a
                      href={item?.button?.link}
                      className="card_button"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {item?.button?.label}
                    </a>
                  </div>
                </PricingCard>
              );
            })}
          </InnerWrapper>
        </PricingArea>
      </Container>
    </SectionWrapper>
  );
};

export default PricingPolicy;
